"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = __importDefault(require("../config/Config"));
const Logger_1 = require("../utils/Logger");
const InjectableDef_1 = __importDefault(require("./InjectableDef"));
class Registry {
    constructor() {
        this.injectables = {};
        this.identifierByName = {};
        this.names = [];
    }
    register(definition, args = {}) {
        const { name } = args;
        this.checkHas(definition, name);
        const id = getAsString(definition.name);
        this.injectables[id] = new InjectableDef_1.default(id, definition, args);
        if (name) {
            const lowerName = getAsString(name);
            this.names.push(lowerName);
            this.identifierByName[lowerName] = id;
        }
        return id;
    }
    unregister(definition, args = {}) {
        const { name } = args;
        const id = getAsString(definition.name);
        if (!this.injectables[id]) {
            return;
        }
        delete this.injectables[id];
        if (name) {
            const lowerName = getAsString(name);
            const index = this.names.findIndex(n => n === lowerName);
            this.names.splice(index, 1);
            delete this.identifierByName[lowerName];
        }
    }
    checkHas(def, name = '') {
        const id = getAsString(def.name);
        if (name && this.hasName(name)) {
            (0, Logger_1.error)(`There already is a injectable named '${name}' registered.`);
        }
        else if (this.hasName(id)) {
            (0, Logger_1.error)(`There already is a injectable named '${id}' registered.`);
        }
        else if (name && this.has(name)) {
            (0, Logger_1.error)(`There already is a injectable '${name}' registered.`);
        }
        else if (this.has(id)) {
            (0, Logger_1.error)(`There already is a injectable '${id}' registered.`);
        }
    }
    has(ref = '') {
        const str = getAsString(ref);
        return this.hasName(ref) || !!this.injectables[str];
    }
    hasName(name = '') {
        const str = getAsString(name);
        return this.names.indexOf(str) > -1;
    }
    get(ref = '') {
        const str = getAsString(ref);
        const name = this.identifierByName[str];
        return this.injectables[str] || this.injectables[name] || null;
    }
    getId(ref = '') {
        const str = getAsString(ref);
        return this.identifierByName[str] || null;
    }
}
exports.default = Registry;
function getAsString(str) {
    if (Config_1.default.isStrict()) {
        return String(str);
    }
    return String(str).toLowerCase();
}
//# sourceMappingURL=Registry.js.map